import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import Select from "react-select";

const QUERY = gql`
  query Catalogs($where: CatalogWhereInput, $limit: Int, $skip: Int) {
    catalogs(where: $where, limit: $limit, skip: $skip) {
      data {
        id
        coverImage
        title
        type
        isPublic
        createdAt
        updatedAt
      }
      total
    }
  }
`;

export default function ListCatalogs({
  className,
  style,
  onChange,
  disabled,
  value,
}) {
  const [getData, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [fetchData, { data, loading }] = useLazyQuery(QUERY);

  useEffect(() => {
    fetchData({
      variables: {
        where: {
          isPublic: 1,
        },
      },
    });
  }, []);

  useEffect(() => {
    const results = data?.catalogs?.data || [];
    if (results?.length > 0) {
      const _results = results.map((_data) => {
        const object = {
          ..._data,
          value: _data?.id,
          label: _data?.title + " [ " + _data?.type + " ]",
        };
        return object;
      });
      setData(_results);
    } else {
      setData([]);
    }
  }, [data]);

  //set value
  useEffect(() => {
    if (value) {
      const result = getData?.filter((_data) => _data?.id === value);
      setSelectedOption(result[0] || null);
    } else {
      setSelectedOption(null);
    }
  }, [getData, value]);

  return (
    <div style={{ width: "100%", color: "black", fontSize: 16, marginTop: 7 }}>
      <Select
        styles={style}
        className={className}
        isDisabled={disabled}
        value={selectedOption}
        placeholder={loading ? "ກຳລັງໂຫຼດ..." : "ເລືອກໝວດໝູ່"}
        onChange={(res) => {
          setSelectedOption(res);
          if (onChange) {
            onChange(res);
          }
        }}
        options={getData}
      />
    </div>
  );
}
